exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-aluno-js": () => import("./../../../src/pages/aluno.js" /* webpackChunkName: "component---src-pages-aluno-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mobile-js": () => import("./../../../src/pages/mobile.js" /* webpackChunkName: "component---src-pages-mobile-js" */),
  "component---src-pages-responsavel-js": () => import("./../../../src/pages/responsavel.js" /* webpackChunkName: "component---src-pages-responsavel-js" */),
  "component---src-pages-turma-js": () => import("./../../../src/pages/turma.js" /* webpackChunkName: "component---src-pages-turma-js" */)
}

